import { BusinessUnitWrapper, BusinessUnitCriteria, BusinessUnitScenario, BusinessUnit } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { DomainVO } from '../../../vo/core/domain.vo';
import { BusinessUnitVO } from '../../../vo/core/business-unit.vo';
import { Model } from '../../../model/model';
import { ExternalAPI } from '../../../model/external-api';

/**
 * Appels BusinessUnit (get / find)
 * Author LMA
 */
export class BuCmd extends WizCommand<BusinessUnitWrapper> {

  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  } 
  
  /** méthode appelée au retour de la commande */
  public sourceCallback: Function;
  public method: string;

  /** retourne un wrapper pre-alimenté */
  public buWrapper(): BusinessUnitWrapper {
    const wrapper: BusinessUnitWrapper = new BusinessUnitWrapper();
    wrapper.entity = new BusinessUnit();
    wrapper.scenario = new BusinessUnitScenario();
    wrapper.scenario.languageCode = this.model.currentLocaleCode;
    return wrapper;
  }


  /** chargement spécifique sur contextGuard */
  public get(domain: string, bu: string): BuCmd {
    const wrapper: BusinessUnitWrapper = this.buWrapper();
    wrapper.entity.domain = domain;
    wrapper.entity.businessUnitCode = bu;
    wrapper.method = WIZ_COMMAND_METHOD.GET;
    this.method = WIZ_COMMAND_METHOD.GET;
    this.configureRemote(ExternalAPI.BU_API, wrapper);
    return this;
  }

  /** chargement initial. Tout le domaine */
  public find(sourceCallback: Function = null): BuCmd {
    const wrapper: BusinessUnitWrapper = this.buWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.criteria = new BusinessUnitCriteria();
    const doms: DomainVO[] = this.model.connectedUser.allDomains;
    if (doms) {
      wrapper.criteria.domainList = doms.map((item) => item.code);
    } else {
      wrapper.criteria.domain = this.model.domainCode;
    }
    wrapper.criteria.businessUnitCode = null;
    this.configureRemote(ExternalAPI.BU_API, wrapper);
    this.sourceCallback = sourceCallback;
    return this;
  }

  /** chargement initial. Tout LES domaines */
  public findForDom(sourceCallback: Function = null): BuCmd {
    const wrapper: BusinessUnitWrapper = this.buWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.criteria = new BusinessUnitCriteria();
    wrapper.criteria.manageDeprecated = true;
    wrapper.criteria.manageDeleted = true;
    wrapper.criteria.manageDeactivated = true;
    const doms: DomainVO[] = this.model.connectedUser.allDomains;
    if (doms) {
      wrapper.criteria.domainList = doms.map((item) => item.code);
    } else {
      wrapper.criteria.domain = this.model.domainCode;
    }
    wrapper.criteria.businessUnitCode = null;
    this.configureRemote(ExternalAPI.BU_API, wrapper);
    this.sourceCallback = sourceCallback;
    return this;
  }


  /** sur retour, traitement selon la méthode */
  public wizResult() {
    super.wizResult();

    const wrapper: BusinessUnitWrapper = this.result;
    
    if(!!wrapper) {
      if (wrapper.method === WIZ_COMMAND_METHOD.GET) {
        if (wrapper.entity) {
          this.model.currentBUCode = wrapper.entity.businessUnitCode;
          this.model.syncService.checkLocal(this.model.businessUnitEngine.currentBU);
        }
      } else if (wrapper.method === WIZ_COMMAND_METHOD.FIND) {
        this.model.businessUnitEngine.feed(this.result.entities.map((bu) => new BusinessUnitVO(this.model, bu))); // init du modèle
      }
  
      if (this.sourceCallback != null) {
        this.sourceCallback();
      }
    } else {
      console.log('buCmd empty result');
    }


  }

}
